import React from 'react';
import CountUp from 'react-countup';
import { Box, Copy } from '../../SimpleUI';
import PropTypes from 'prop-types';

const ResumeNumber = ({ prefix, digits, suffix, children, isVisible }) => {
  return (
    <Box maxWidth="max-content">
      <Box textAlign="center">
        {prefix && (
          <Copy
            fontSize="_landingResumeSymbols"
            textAlign="center"
            color="_darkGray"
            tag="span"
          >
            {prefix}
          </Copy>
        )}
        {isVisible ? (
          <Copy
            fontSize="_landingResumeNumber"
            textAlign="center"
            color="_darkGray"
            tag="span"
          >
            <CountUp start={0} end={digits} />
          </Copy>
        ) : (
          digits
        )}
        {suffix && (
          <Copy
            fontSize="_landingResumeSymbols"
            textAlign="center"
            color="_darkGray"
            tag="span"
          >
            {suffix}
          </Copy>
        )}
      </Box>
      <Box>
        <Copy
          fontSize="_newTitle"
          fontWeight="medium"
          textAlign="center"
          color="_darkGray"
        >
          {children}
        </Copy>
      </Box>
    </Box>
  );
};

ResumeNumber.propTypes = {
  prefix: PropTypes.string,
  digits: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export { ResumeNumber };
